/**
 * PainelPremium — o palco em tela cheia das telas do funil Premium (5–8).
 *
 * Portal no `body` (um ancestral com transform, como as sub-telas em push,
 * transformaria o `fixed` em `absolute`), role=dialog, trava do scroller do
 * app (useOverlayScrollLock) e o voltar do Android pela pilha de overlays
 * (utils/offcanvasStack): voltar chama `onVoltar` quando existe, senão
 * `onFechar`. Esc faz o mesmo no navegador.
 *
 * O fundo é opaco desde o primeiro quadro — só o conteúdo anima. Assim trocar
 * de uma tela do funil para a seguinte (uma desmonta, a outra monta no mesmo
 * commit) nunca deixa o app aparecer por baixo.
 *
 * `brilho`: onde fica o glow radial do accent — 'centro' (Oferta, Lembrete) ou
 * 'topo' (Comparativo, Planos).
 */

import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import cx from '../../design/cx';
import useOverlayScrollLock from '../../hooks/useOverlayScrollLock';
import { registrarOffcanvas, removerOffcanvas } from '../../utils/offcanvasStack';
import s from './PainelPremium.module.scss';

export default function PainelPremium({
  rotulo,
  brilho = 'centro',
  onFechar,
  onVoltar,
  children,
  className = '',
}) {
  const painel = useRef(null);
  // Lido na hora do gesto: o handler da pilha nunca fica velho.
  const sair = useRef(null);
  sair.current = onVoltar || onFechar;

  useOverlayScrollLock(true);

  useEffect(() => {
    const id = registrarOffcanvas(() => sair.current?.());
    const aoTeclar = (e) => {
      if (e.key === 'Escape') sair.current?.();
    };
    window.addEventListener('keydown', aoTeclar);
    painel.current?.focus({ preventScroll: true });
    return () => {
      removerOffcanvas(id);
      window.removeEventListener('keydown', aoTeclar);
    };
  }, []);

  const conteudo = (
    <div
      ref={painel}
      className={cx(s.raiz, brilho === 'topo' ? s.brilhoTopo : s.brilhoCentro, className)}
      role="dialog"
      aria-modal="true"
      aria-label={rotulo}
      tabIndex={-1}
    >
      <div className={s.coluna}>{children}</div>
    </div>
  );

  return typeof document === 'undefined' ? conteudo : createPortal(conteudo, document.body);
}
